module.exports = __webpack_public_path__ + "img/source3_12.7c8b593c.png";